import React from "react";
import styled from "@emotion/styled";

import { Color } from "../../utils/color";

export const CompanyInput = () => {
  return (
    <SInput>
      <label>
        *会社名
        <input type="text" placeholder="デマンドリンク株式会社" />
      </label>
    </SInput>
  );
};

const SInput = styled.div`
  label {
    display: flex;
    flex-direction: column;
    font-size: 0.9rem;
    font-weight: 500;
    color: ${Color.dark};
    line-height: 1;
    input {
      margin-top: 1.5rem;
      width: 100%;
      border: none;
      border: 1px solid ${Color.light};
      background-color: ${Color.light};
      border-radius: 8px;
      padding: 1rem 1.5rem;
      font-size: 0.9rem;
      line-height: 1;
      transition: border 0.2s;
      &:focus {
        outline: none;
        border: 1px solid ${Color.primary};
      }
    }
  }
`;
